import { useAIChatSummary } from 'hooks/useAIChatSummary'
import useHasFeature, { AppFeatures, AppSubFeatures } from 'hooks/useHasFeature'
import React from 'react'
import { ContactState } from 'store/case/case.state'
import { ChatTranscripts } from 'views/Chat/ChatTranscripts'
import AISummary from 'widgets/AISummary'
import { ChatHistoryTranscript } from 'widgets/ChatHistoryTranscript'

interface Props {
    contact: ContactState
}

const ChatHistoryContactView: React.FC<Props> = ({ contact }) => {
    const hasFeature = useHasFeature()

    const showChatHistoryTranscript = hasFeature(AppFeatures.CHAT, [
        AppSubFeatures.CHAT_HISTORY_TRANSCRIPT,
    ])

    const { summaryConfig, contactLensSummaryConfig, showAISummary, showContactLensSummary } =
        useAIChatSummary()

    return (
        <>
            {showAISummary && <AISummary contact={contact} {...summaryConfig} />}

            {showChatHistoryTranscript &&
                (contact.attributes?.['sa-social-media-platform'] ? (
                    <ChatTranscripts contactID={contact.ID} />
                ) : (
                    <ChatHistoryTranscript contact={contact} />
                ))}

            {showContactLensSummary && (
                <AISummary contact={contact} {...contactLensSummaryConfig} />
            )}
        </>
    )
}

export default ChatHistoryContactView
